import React from "react";

type Props = {
  path: string;
  text?: string;
  token: string;
};

const YahooLoginButton: React.FC<Props> = (props) => {
  const { path, text = "Yahoo! JAPAN IDでログイン", token } = props;
  return (
    <form method="POST" action={path}>
      <input type="hidden" name="authenticity_token" value={token} />
      <button
        type="submit"
        aria-label={text}
        className="hover:cursor-pointer link-hover-none hover:bg-[#FF0033] before:mr-[10px] left-icon icon-yahoo-white !bg-[#FF0033] h-[50px] font-raleway rounded-default block flex items-center justify-center w-full text-white text-sm"
      >
        {text}
      </button>
    </form>
  );
};

export default YahooLoginButton;
